import { useLazyQuery as y } from "@apollo/client";
import { currencyInfoSchema as h } from "../../deserialize/yup/currency.js";
import b from "../../graphql/query/getCurrencyInfo.js";
import * as e from "ramda";
import { useState as g, useCallback as n } from "react";
const x = () => {
  const [r, { refetch: a }] = y(b), [c, p] = g(null), m = n(
    async (f) => {
      const i = await r({ variables: {
        name: f
      } }), o = e.path(
        ["data", "getClaimableRewardTypeInfosByRewardName"],
        i
      );
      if (e.isNil(o))
        return null;
      const l = e.map(
        (t) => h.cast(t),
        o
      ), d = e.groupBy(
        e.prop("type"),
        l
      ), s = e.mapObjIndexed(
        (t) => e.head(t),
        d
      );
      return p(s), s;
    },
    [r]
  ), u = n(async () => {
    a();
  }, [a]);
  return {
    data: c,
    fetch: m,
    refetch: u
  };
};
export {
  x as default
};
//# sourceMappingURL=useGetCurrencyInfo.js.map
